import { gql } from '@apollo/client/core'

import { PAGE_INFO_ATTRIBUTES } from './fragments'

export const DOCUMENTS_INDEX_QUERY = gql`
  query documents(
    $first: Int
    $last: Int
    $offset: Int
    $after: String
    $before: String
    $modelId: ID
    $modelType: String
    $documentType: String
  ) {
    documents(
      first: $first
      last: $last
      offset: $offset
      after: $after
      before: $before
      modelId: $modelId
      modelType: $modelType
      documentType: $documentType
    ) {
      nodes {
        id
        name
        size
        documentType
        modelId
        modelType
        url
        thumbnailUrl
      }
      pageInfo {
        ...pageInfoAttributes
      }
      totalCount
      maxPageSize
      pageIndex
    }
  }
  ${PAGE_INFO_ATTRIBUTES}
`
